import React, { useState } from 'react';
import { PlusIcon } from '../assets/svgImages';
import { MinusIcon } from '../assets/svgImages';
import { DataTableProps } from '../interface/interface';

const CollapsibleDataTable = ({
  data,
  visibleColumns,
  hiddenColumns,
  imageColumn,
  alwaysOpen = false,
  className,
  withRadioButtons = false,
  handleTokenRadio,
  handleSubTokenRadio,
  step,
  sasAddButon = false,
}: DataTableProps) => {
  const [openRowIndex, setOpenRowIndex] = useState<number | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const handleRowClick = (index: number) => {
    setOpenRowIndex(openRowIndex === index ? null : index);
  };

  const handleRadioButtonChange = (index: number) => {
    setSelectedRowIndex(index);
  };

  const isDetailsVisible = (row: any) => {
    return hiddenColumns.some((column) => !!row[column]);
  };

  return (
    <div
      className={`overflow-x-auto rounded-md ${alwaysOpen ? 'bg-secondary-pink-50' : 'bg-secondary-cornflowerblue-100'} p-2`}
    >
      <table
        className={`w-full table-auto spaced-table border-separate cart-table ${className}`}
      >
        <thead className="bg-primary-blue-500">
          <tr>
            {withRadioButtons && <th className="p-4"></th>}{' '}
            {/* Empty header for radio buttons */}
            {imageColumn && (
              <th className="p-4 text-white text-base font-semibold">
                Product Image
              </th>
            )}
            {visibleColumns.map((column, columnIndex) => (
              <th
                key={columnIndex}
                className="p-4 text-white text-base font-semibold"
              >
                {column}
              </th>
            ))}
            {!alwaysOpen && hiddenColumns.length > 0 && !sasAddButon && (
              <th className="p-4 text-white text-base font-semibold">
                Details
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              {!alwaysOpen && (
                <tr
                  onClick={() => handleRowClick(rowIndex)}
                  className={`cursor-pointer ${row.invalid ? 'bg-primary-red-50' : 'bg-white'}`}
                >
                  {withRadioButtons && (
                    <td className="p-4 text-center">
                      <input
                        type="radio"
                        name="rowSelection"
                        checked={
                          step && step === 1
                            ? row.id === handleTokenRadio?.state?.id
                            : row.id === handleSubTokenRadio?.state?.id
                        }
                        onChange={() => {
                          if (step && step === 1) {
                            handleTokenRadio?.setter(() => ({
                              id: row.id,
                              token: row.Token,
                              productId: row.productId,
                            }));
                          } else if (step && step === 2) {
                            handleSubTokenRadio?.setter(() => ({
                              id: row.id,
                              token: row.Token,
                            }));
                          }
                        }}
                      />
                    </td>
                  )}
                  {imageColumn && (
                    <td className="p-4 flex text-left justify-center">
                      <img
                        src={row[imageColumn]}
                        alt="Product Image"
                        className="w-12 h-20 rounded-md"
                      />
                    </td>
                  )}
                  {visibleColumns.map((column, columnIndex) => (
                    <td
                      key={columnIndex}
                      className="p-4 text-center text-primary-blue-500 font-regular text-sm"
                    >
                      {row[column]}
                    </td>
                  ))}

                  {!row.hideHiddenColumns ? (
                    <>
                      {!alwaysOpen && hiddenColumns.length > 0 && (
                        <td className=" p-4 flex justify-center items-center text-center">
                          {openRowIndex === rowIndex ? (
                            <MinusIcon />
                          ) : (
                            <PlusIcon />
                          )}
                        </td>
                      )}
                    </>
                  ) : (
                    <p></p> // Just to fill up the empty space
                  )}
                </tr>
              )}
              {!row.hideHiddenColumns && (
                <>
                  {(alwaysOpen ? true : openRowIndex === rowIndex) &&
                    isDetailsVisible(row) && (
                      <tr className={`${alwaysOpen && 'bg-secondary-pink-50'}`}>
                        <td
                          colSpan={
                            visibleColumns.length +
                            (imageColumn ? 1 : 0) +
                            (hiddenColumns.length > 0 ? 1 : 0) +
                            (withRadioButtons ? 1 : 0)
                          }
                          className={'p-6'}
                        >
                          {alwaysOpen && (
                            <h6 className="mb-5 ml-3 xl:text-xl font-bold text-primary-blue-500">
                              Prescription Details
                            </h6>
                          )}

                          <div
                            className={`flex flex-wrap table-child-row hidden-info justify-between 
                          ${row.invalid ? 'bg-primary-red-50' : alwaysOpen ? 'bg-secondary-pink-50' : 'bg-white'}`}
                          >
                            {hiddenColumns.map((column, columnIndex) => (
                              <div
                                key={columnIndex}
                                className="w-full sm:w-1/2 md:w-1/3 lg:w-max px-4 mb-4 3xl:mb-0 "
                              >
                                <div className="font-semibold text-primary-blue-500 text-base">
                                  {column}
                                </div>
                                <div className="text-center text-primary-blue-500 font-regular text-sm">
                                  {row[column]}
                                </div>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                </>
              )}

              {alwaysOpen && (
                <tr
                  onClick={() => handleRowClick(rowIndex)}
                  className={`cursor-pointer ${row.invalid ? 'bg-primary-red-50' : 'bg-white'}`}
                >
                  {withRadioButtons && (
                    <td className="p-4 text-center">
                      <input
                        type="radio"
                        name="rowSelection"
                        checked={selectedRowIndex === rowIndex}
                        onChange={() => handleRadioButtonChange(rowIndex)}
                      />
                    </td>
                  )}
                  {imageColumn && (
                    <td className="p-4 flex text-left justify-center">
                      <img
                        src={row[imageColumn]}
                        alt="Product Image"
                        className="w-20 h-20 rounded-md"
                      />
                    </td>
                  )}
                  {visibleColumns.map((column, columnIndex) => (
                    <td
                      key={columnIndex}
                      className="p-4 text-center text-primary-blue-500 font-regular text-sm"
                    >
                      {row[column]}
                    </td>
                  ))}

                  {!alwaysOpen && hiddenColumns.length > 0 && (
                    <td className=" p-4 flex justify-center items-center text-center">
                      {openRowIndex === rowIndex ? <MinusIcon /> : <PlusIcon />}
                    </td>
                  )}
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CollapsibleDataTable;
